"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = fetchConsentCopy;

var _apiClient = _interopRequireDefault(require("hub-http/clients/apiClient"));

var _hubspot = _interopRequireDefault(require("hubspot.PortalIdParser"));

var _constants = require("./constants");

var _addDefaultConsentCopy = _interopRequireDefault(require("./addDefaultConsentCopy"));

var HUB_SETTINGS_ENDPOINT = 'hubs/v1/settings';

var portalId = _hubspot.default.get();

function transformHubSettingsArray(hubSettings) {
  var settings = {};
  hubSettings.forEach(function (setting) {
    return settings[setting.key] = setting.value;
  });
  return settings;
} // Fetches user-defined consent copy from hub settings and calls the given callback with the defaults and user overrides


function fetchConsentCopy() {
  return _apiClient.default.get(HUB_SETTINGS_ENDPOINT, {
    query: {
      portalId: portalId,
      keys: _constants.HUB_SETTINGS_CONSENT_KEYS
    }
  }).then(function (response) {
    if (response.hasOwnProperty('settings')) {
      return (0, _addDefaultConsentCopy.default)(transformHubSettingsArray(response.settings));
    }

    return response;
  });
}

module.exports = exports.default;